<template>
  <div class="search__product__button mt-1">
    <div v-show="!basketAmount" class="add-cart">
      <button
          :class="`btn add-cart__button add-cart__button__big rounded-25`"
          @click="changeProductAmount(product.id, 1)"
      >
        {{ product.isPreorder ? dictionary.addToCartPreorder : dictionary.addToCart }}
      </button>
    </div>
    <div v-show="basketAmount > 0" class="add-cart">
      <button class="add-cart__button" @click="changeProductAmount(product.id, basketAmount - 1)">-</button>

      <input
          :id="`counter-${product.id}`"
          class="add-cart__input"
          :value="basketAmount"
          type="number"
          @change="inputAmountChanged(product.id, $event)"
      />

      <label :title="dictionary.maxAmountPerOrder" class="add-cart__pieces" :for="`counter-${product.id}`">{{ dictionary.pieces }}</label>

      <div v-if="basketAmount >= product.maxAmountPerOrder" class="maxAmountPerOrder">
        {{ dictionary.maxAmountPerOrder }}
      </div>
      <button v-if="basketAmount >= product.maxAmountPerOrder" disabled class="add-cart__button add-cart__button--lg">
        +
      </button>
      <button v-else class="add-cart__button add-cart__button--lg"
              @click="changeProductAmount(product.id, basketAmount + 1)">
        +
      </button>

    </div>
  </div>
</template>

<script>

export default {
  props: {
    product: [],
    basketAmount: {
      type: Number,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    itemListName: {
      type: String,
      default: '',
    }
  },

  methods: {
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    inputAmountChanged(itemId, $event) {
      this.changeProductAmount(itemId, parseInt($event.target.value));
    },

    changeProductAmount(productId, amount) {
      this.$emit('addProductToBasket', {
        product: this.product,
        amount,
        showPreBasket: false,
        itemListName: this.itemListName,
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.search__product__button .add-cart {
  margin-top: 15px;
  min-height: 31px;
  min-width: 125px;
  justify-content: space-between;
  position: relative;

  @media (min-width: 980px) {
      min-width: 160px;
  }

  &:hover {
    .maxAmountPerOrder {
      display: block;
    }
  }
}

.maxAmountPerOrder {
  position: absolute;
  bottom: 39px;
  text-align: center;
  background: #ddd;
  padding: 5px;
  border-radius: 5px;
  display: none;
}
</style>
